/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Row } from "jsxstyle";
import PropTypes from "prop-types";
import useForm from "hooks/useForm";
import useQueryStringFilters from "hooks/useQueryStringFilters";
import Form from "components/Form";
import Button from "components/Button";
import Grid from "components/FormGrid";
import FormGroup from "components/FormGroup";
import Separator from "components/Separator";
import InputGroup from "components/InputGroup";
import SelectEntityMaster from "components/SelectEntityMaster";
import SelectHYFund from "components/SelectHYFund";

function ContactFilters({ onChange }) {
  const { getQuery } = useQueryStringFilters();
  const query = getQuery();
  const { getValue, setValue, clear, submit, clearCount } = useForm({
    onSubmit: onChange,
    initialValues: {
      criteria: query.criteria,
      contact_name: query.contact_name,
      company_id: query.company_id,
      fund_id: query.fund_id,
    },
  });

  React.useEffect(() => {
    if (clearCount) {
      submit();
    }
  }, [clearCount]);

  return (
    <React.Fragment>
      <Form onSubmit={submit}>
        <Grid>
          <Grid.Item>
            <FormGroup>
              <InputGroup
                leftIcon="search"
                placeholder="Search by id"
                value={getValue("contact_id")}
                onChange={(value) => setValue("contact_id", value)}
                fullWidth
              />
            </FormGroup>
          </Grid.Item>
          <Grid.Item>
            <FormGroup>
              <InputGroup
                placeholder="Search by contact name"
                value={getValue("name")}
                onChange={(value) => setValue("name", value)}
              />
            </FormGroup>
          </Grid.Item>
          <Grid.Item>
            <FormGroup>
              <SelectEntityMaster
                placeholder="Search by company"
                value={getValue("company_id")}
                onSelect={(value) => setValue("company_id", value)}
              />
            </FormGroup>
          </Grid.Item>
          <Grid.Item>
            <FormGroup>
              <SelectHYFund
                placeholder="Search by Fund"
                value={getValue("fund_id")}
                onSelect={(value) => setValue("fund_id", value)}
              />
            </FormGroup>
          </Grid.Item>
          <Grid.Item>
            <Row>
              <Button
                intent="primary"
                icon="search"
                text="Search"
                type="submit"
              />
              <Separator />
              <Button intent="none" text="Clear filters" onClick={clear} />
            </Row>
          </Grid.Item>
        </Grid>
      </Form>
    </React.Fragment>
  );
}

ContactFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default ContactFilters;
